import React, { useState } from 'react'
// import { Container } from 'react-bootstrap';
// import { Media } from './images/Pics.js';
import { Medias } from '../images/Pics-2';
import { Link } from 'react-router-dom';

const Productsrange = () => {
  const [file, setFile] = useState(null);

  return (
    <div>
      <div id="service" className="outer-page-content-container">
        <div className="products-galary-bg">
          <div className="container">
            <div className="wpb_wrapper">
              <div className="wbc-heading clearfix">
                <div className="default-heading">WHAT MAKES US GREAT</div>
              </div>
              <div className="wbc-heading clearfix">
                <h3 className="special-heading-3">
                  OUR <span className="wbc-color">PRODUCTS RANGE</span>
                </h3>
              </div>
              <hr className="wbc-hr" />
              <div className="wbc-heading clearfix">
                <div className="default-heading">
                  Welcome to India's Top Manufacturer and Exporter of Granite,
                  Marbles. PM International is a wonderful hub for the finest
                  quality Indian granite with a broad selection of marbles. The
                  architecture of households, offices, commercial buildings,
                  hospitals, schools, and other structures serves the collection
                  of diverse granite and marbles.
                </div>
              </div>
            </div>
            <div className="media-container">
              {Medias.map((file, index) => (
                <div
                  className="media"
                  key={index}
                  onClick={() => setFile(file)}
                >
                  {file.type === "image" ? (
                    <div className="cards-list">
                      <div className="card-stone 1">
                        <div className="card_image">
                          {" "}
                          <img src={file.url} alt="#" />{" "}
                        </div>
                        <div className="card_title title-white">
                          <p>{file.title}</p>
                        </div>
                      </div>
                    </div>
                  ) : null}
                </div>
              ))}
            </div>

            <div
              className="popup-media"
              style={{ display: file ? "block" : "none" }}
            >
              <span onClick={() => setFile(null)}>&times;</span>
              {file?.type === "image" ? (
                <img src={file?.url} alt="next"></img>
              ) : null}
            </div>
          </div>

          <Link to="/products">
            <h2 className="button-About">
              <button className="bn632-hover bn18">
                View More
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="16"
                  height="16"
                  fill="currentColor"
                >
                  <path fill="none" d="M0 0h24v24H0z"></path>
                  <path d="M16.1716 10.9999L10.8076 5.63589L12.2218 4.22168L20 11.9999L12.2218 19.778L10.8076 18.3638L16.1716 12.9999H4V10.9999H16.1716Z"></path>
                </svg>
              </button>
            </h2>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Productsrange
